import React from 'react';
import { Link } from 'react-router-dom';
import { ContainerFull, ContainerItem, H2, TextLink } from '../../../components/common';

export default function Terms() {
  return (
    <ContainerFull>
      <H2>Gamma Terms of Use</H2>
      <ol>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Introduction and Acceptance
          </div>
          <div style={{ marginBottom: '10px' }}>
            Welcome to gamma.io (the “Site”), owned and operated by Gamma.io Inc., a Delaware
            corporation (“Gamma,” “we,” “us”, or “our”). The following terms and conditions,
            together with any documents they expressly incorporate by reference (collectively, the
            “Terms”), govern your access and use of the Site, and any content, features,
            functionality, and services offered on or through the Site, including without
            limitation, using the Site to view, explore, and create NFTs, and using our tools, at
            your own discretion, to connect directly with others to purchase, sell, or transfer NFTs
            on public blockchains (collectively, the “Service”). For purposes of these terms, “NFT”
            means a non-fungible token or similar digital item implemented on a blockchain (such as
            the Bitcoin blockchain), which uses smart contracts to link to or otherwise be
            associated with certain content or data.
          </div>
          <div style={{ marginBottom: '10px' }}>
            PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE YOU START TO USE THE SERVICE AS THESE
            TERMS CONTAIN IMPORTANT INFORMATION AND AFFECT YOUR LEGAL RIGHTS. AS OUTLINED IN SECTION
            15 BELOW, THEY INCLUDE A MANDATORY ARBITRATION AGREEMENT AND CLASS ACTION WAIVER THAT
            (WITH LIMITED EXCEPTIONS) REQUIRE ANY DISPUTES BETWEEN US TO BE RESOLVED THROUGH
            INDIVIDUAL ARBITRATION RATHER THAN BY A JUDGE OR JURY IN COURT.
          </div>
          <div style={{ marginBottom: '10px' }}>
            BY USING THE SERVICE AND CLICKING TO ACCEPT THESE TERMS WHEN THIS OPTION IS MADE
            AVAILABLE TO YOU, YOU AGREE TO BE BOUND BY THESE TERMS AND ALL OF THE TERMS INCORPORATED
            HEREIN BY REFERENCE, INCLUDING THE <Link to="/privacy">PRIVACY POLICY</Link>. IF YOU DO
            NOT AGREE TO THESE TERMS OR THE PRIVACY POLICY, YOU MUST NOT ACCESS OR USE THE SERVICE.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Changes to Terms of Use; Additional Terms
          </div>
          <div style={{ marginBottom: '10px' }}>
            Gamma reserves the right to change or modify these Terms at any time and in our sole
            discretion. All changes are effective immediately when we post them, and apply to all
            access to and use of the Service. If we make material changes to these Terms, we will
            use reasonable efforts to provide notice of such changes, such as by providing notice
            through the Service or updating the “Last Updated” date at the beginning of these Terms.
            By continuing to access or use the Service, you confirm your acceptance of the revised
            Terms and all of the terms incorporated therein by reference effective as of the date
            these Terms are updated. It is your sole responsibility to review the Terms from time to
            time, to view such changes, and ensure that you understand the terms and conditions that
            apply when you access or use the Service.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Because we have a growing number of services, we sometimes need to provide additional
            terms for specific services (and such services are deemed part of the “Service”
            hereunder and shall also be subject to these Terms). Those additional terms and
            conditions, which are available with the relevant service, then become part of your
            agreement with us if you use those services. In the event of a conflict between these
            Terms and any additional applicable terms we may provide for a specific service, such
            additional terms shall control for that specific service.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Service Overview and Site Access
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Overview</div>
          <div style={{ marginBottom: '10px' }}>
            Gamma is not a wallet provider, exchange, broker, financial institution, or creditor.
            Gamma provides a peer-to-peer web3 service that helps users discover and directly
            interact with each other and NFTs available on public blockchains. We do not have
            custody or control over the NFTs or blockchains you are interacting with, and we do not
            execute or effectuate purchases, transfers, or sales of NFTs. To use our Service, you
            must use a third-party wallet (e.g., Hiro) which allows you to engage in transactions on
            blockchains.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Gamma is not party to any agreement between any users. You bear full responsibility for
            verifying the identity, legitimacy, and authenticity of NFTs that you purchase from
            third-party sellers using the Service and we make no claims about the identity,
            legitimacy, functionality, or authenticity of users or NFTs (and any content associated
            with such NFTs) visible on the Service.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Account</div>
          <div style={{ marginBottom: '10px' }}>
            You will need a blockchain address and a third-party wallet to access the Service. Your
            blockchain address functions as your identity on the Site. You may, but are not required
            to, create a Gamma user account to use the Service. For purposes of these Terms, your
            blockchain address or account created on Gamma are hereafter referred to as your
            “Account.” Your Account will be associated with your linked blockchain address and
            display the NFTs for that blockchain address (and, if applicable, any content associated
            with such NFTs).
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Eligibility</div>
          <div style={{ marginBottom: '10px' }}>
            You must be at least 18 years old to use the Service. If you are at least 13 years old
            but under 18 years old, you may only use the Service through a parent or guardian’s
            Account and with their approval and oversight, and the parent or guardian Account holder
            is responsible for your actions using the Account. It is prohibited to use our Service
            if you are under 13 years old.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Privacy</div>
          <div style={{ marginBottom: '10px' }}>
            All information we collect on this Site and through the Service is subject to our
            <Link to="/privacy">Privacy Policy</Link>. By using the Service, you consent to all
            actions taken by us with respect to your information in compliance with the Privacy
            Policy.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            Your Responsibility
          </div>
          <div style={{ marginBottom: '10px' }}>
            You represent and warrant that all the information that you provide in order to use the
            Service is true, accurate, current, and complete. You understand that you are solely
            responsible for (and that we have no responsibility to you or to any third party for)
            any breach of your obligations under these Terms and for the consequences including any
            loss or damage which we may suffer) of any such breach.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            Compliance with Law
          </div>
          <div style={{ marginBottom: '10px' }}>
            You also represent and warrant that you will comply with all applicable laws (e.g.,
            local, state, federal, and other laws) when using the Service. Without limiting the
            foregoing, by using the Service, you represent and warrant that: (a) you are not located
            in a country that is subject to a U.S. Government embargo or that has been designated by
            the U.S. Government as a “terrorist supporting” country; and (b) you have not been
            identified as a Specially Designated National (as that term is defined by the Office of
            Foreign Assets Control of the U.S. Department of the Treasury) or placed on any U.S.
            Government list of prohibited, sanctioned, or restricted parties. We make no claims
            regarding our Site outside of the United States. If you access or use the Service
            outside the United States, you do so at your own risk and you are solely responsible for
            ensuring that your access and use of the Service in such country, territory or
            jurisdiction does not violate any applicable laws.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Gamma may require you to provide additional information and documents in certain
            circumstances, such as at the request of any government authority, as any applicable law
            or regulation dictates, or to investigate a potential violation of these Terms. In such
            cases, Gamma, in its sole discretion, may disable your Account and block your ability to
            access the Service until such additional information and documents are processed by
            Gamma. If you do not provide complete and accurate information in response to such a
            request, Gamma may refuse to restore your access to the Service.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            Access Limitations
          </div>
          <div style={{ marginBottom: '10px' }}>
            You shall be solely responsible for providing, maintaining and ensuring compatibility
            with the Service access requirements, all hardware, software, electrical or other
            physical requirements for your use of the Service, including without limitation, mobile
            devices, telecommunications and Internet service provider access, connections, links,
            web browsers or other equipment, programs and services required to access the Internet
            or the Service. You acknowledge and agree that from time to time the Service may be
            inaccessible or inoperable for any reason, including without limitation: (i) equipment
            malfunctions, (ii) periodic maintenance procedures or repairs; or (iii) other causes
            beyond our control. Additionally, because the Service is accessed via the Internet or a
            mobile carrier, you may have connection issues due solely to your own Internet or
            telecommunications service provider or other technological access requirements. We are
            not responsible for any third-party access requirements (e.g., your ISP).
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            User Restrictions
          </div>
          <div style={{ marginBottom: '10px' }}>
            You agree that you will not violate any law, contract, intellectual property, or other
            third-party right, and that you are solely responsible for your conduct and content
            while accessing or using the Service. You also agree that you will not:
          </div>
          <ul style={{ marginBottom: '10px' }}>
            <li style={{ marginBottom: '10px' }}>
              Use or attempt to use another user’s Account without authorization from such user;
            </li>
            <li style={{ marginBottom: '10px' }}>Pose as another person or entity;</li>
            <li style={{ marginBottom: '10px' }}>
              Access the Service from a different blockchain address if we have blocked any of your
              other blockchain addresses from accessing the Service, unless you have our written
              permission first;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Distribute spam, including through sending unwanted NFTs to other users;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Damage, disable, overburden, or impair the functioning of the Service in any manner;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Bypass or ignore instructions that control access to the Service, including attempting
              to circumvent any rate limiting systems, directing traffic through multiple IP
              addresses, or otherwise obfuscating the source of traffic you send to Gamma;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use any data mining, robot, spider, crawler, scraper, script, browser extension,
              offline reader, or other automated means or interface not authorized by us to access
              the Service, extract data, or otherwise interfere with or modify the rendering of
              Service pages or functionality;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Reverse engineer, duplicate, decompile, disassemble, or decode any aspect of the
              Service, or do anything that might discover source code or bypass or circumvent
              measures employed to prevent or limit access to any service, area, or code of the
              Service;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Sell or resell the Service or attempt to circumvent any Gamma fee systems;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Engage in behaviors that have the intention or the effect of artificially causing an
              item or collection to appear at the top of search results, or artificially increasing
              view counts, favorites, or other metrics that Gamma might use to sort search results;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service or data collected from our Service for any advertising or direct
              marketing activity (including without limitation, email marketing, SMS marketing, and
              telemarketing);
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service for money laundering, terrorist financing, or other illicit finance;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service from a country sanctioned by the government of the United States or to
              facilitate transactions involving individuals sanctioned by the government of the
              United States or located in sanctioned countries;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service to carry out any financial activities subject to registration or
              licensing, including but not limited to creating, selling, or buying securities,
              commodities, options, or debt instruments;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service to create, sell, or buy NFTs or other items that give owners’ rights
              to participate in an ICO or any securities offering, or that are redeemable for
              securities, commodities, or other financial instruments;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service to engage in price manipulation, fraud, or other deceptive,
              misleading, or manipulative activity;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service to buy, sell, or transfer stolen items, fraudulently obtained items,
              items taken without authorization, and/or any other illegally obtained items;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Infringe or violate the intellectual property rights or any other rights of others;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Create or display illegal content, such as content that may involve child sexual
              exploitation;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Create or display NFTs or other items that promote suicide or self-harm, incites hate
              or violence against others, or doxes another individual;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service for any illegal or unauthorized purpose, including creating or
              displaying illegal content, such as content that may involve child sexual
              exploitation, or encouraging or promoting any activity that violates the Terms;
            </li>
            <li style={{ marginBottom: '10px' }}>
              Use the Service in any manner that could interfere with, disrupt, negatively affect or
              inhibit other users from fully enjoying the Service.
            </li>
          </ul>
          <div style={{ marginBottom: '10px' }}>
            We reserve the right to take action, with or without advance notice, if we believe you
            have violated these Terms, including the restrictions set forth above. This may include
            but is not limited to: (a) removing the ability to view certain NFTs on the Service or
            use our Service to interact with the NFTs; (b) disabling the ability to use the Service
            in conjunction with buying/selling/transferring NFTs available on blockchains; (c)
            disabling your ability to access our Service; and/or (d) other actions.
          </div>
          <div style={{ marginBottom: '10px' }}>
            You bear full responsibility for verifying the authenticity, legitimacy, identity, and
            other details about any NFT, collection, or account that you view or otherwise interact
            with in conjunction with our Service. We make no guarantees or promises about the
            identity, legitimacy, or authenticity of any NFT, collection, or account on the Service.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Third-Party Providers, Content, and Transactions
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            Gamma Third-Party Service Providers
          </div>
          <div style={{ marginBottom: '10px' }}>
            You acknowledge that our contracts with third party suppliers, licensors, developers,
            application and data hosting providers, wireless network services, and other technology
            services providers to provide the Site’s functionality and the Service (“Third Party
            Providers”). For example, all user data and user content is stored at computer data
            centers operated and maintained by Third Party Providers. We are responsible for
            ensuring that the Third-Party Providers abide by these Terms. We are solely responsible
            for monitoring and supervising all necessary work of the Third-Party Providers.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Hyperlinks</div>
          <div style={{ marginBottom: '10px' }}>
            The Service may also contain links or functionality to access or use third-party
            websites and applications, or otherwise display, include, or make available content,
            data, information, services, applications, or materials from third parties. Any third
            party links provided in the Site are provided solely for your convenience. We do not
            review, endorse nor make any representations about such sites, and your use of these
            sites is at your own risk. You agree that we will not be responsible or liable under any
            circumstances or theories, directly or indirectly, for any damage or loss caused or
            alleged to be caused, by or in connection with your use or reliance on these third party
            sites.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Wallet</div>
          <div style={{ marginBottom: '10px' }}>
            By using your wallet in connection with the Service, you agree that you are using that
            wallet under the terms and conditions of the applicable provider of the wallet. Wallets
            are not operated by, maintained by, or affiliated with Gamma, and Gamma does not have
            custody or control over the contents of your wallet and has no ability to retrieve or
            transfer its contents. Gamma accepts no responsibility for, or liability to you, in
            connection with your use of a wallet and makes no representations or warranties
            regarding how the Service will operate with any specific wallet. You are solely
            responsible for keeping your wallet secure and you should never share your wallet
            credentials or seed phrase with anyone. If you discover an issue related to your wallet,
            please contact your wallet provider. Likewise, you are solely responsible for your
            Account and any associated wallet and we are not liable for any acts or omissions by you
            in connection with your Account or as a result of your Account or wallet being
            compromised. You agree to immediately notify us via email at fraudreport@gamma.io if you
            discover or otherwise suspect any security issues related to the Service or your
            Account.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            Third Party Content and Transactions
          </div>
          <div style={{ marginBottom: '10px' }}>
            As a peer-to-peer web3 service, Gamma helps you explore NFTs created by third parties
            and interact with different blockchains. Gamma does not make any representations or
            warranties about this third-party content visible through our Service, including any
            content associated with NFTs displayed on the Service. We make no claims about the
            identity, legitimacy, functionality, or authenticity of users or NFTs. You bear
            responsibility for verifying the legitimacy, authenticity, and legality of NFTs that you
            purchase from third-party sellers using the Service. We also cannot guarantee that any
            NFTs visible on Gamma will always remain visible and/or available to be bought, sold, or
            transferred.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Gamma is not a party to any agreement between users. NFTs may be subject to terms
            directly between buyers and sellers with respect to the use of the NFT content and
            benefits associated with a given NFT (“Purchase Terms”). For example, when you click to
            get more details about any of the NFTs visible on Gamma, you may notice a third party
            link to the creator’s website. Such website may include Purchase Terms governing the use
            of the NFT that you will be required to comply with. Gamma is not a party to any such
            Purchase Terms, which are solely between the buyer and the seller of the subject NFTs.
            The buyer and seller are entirely responsible for communicating, promulgating, agreeing
            to, and enforcing Purchase Terms. You are solely responsible for reviewing such Purchase
            Terms.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Intellectual Property Rights
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            Ownership of the Service
          </div>
          <div style={{ marginBottom: '10px' }}>
            The Service and its entire contents, features, and functionality, including, but not
            limited to, the “look and feel” of the Service, data files, graphics, text, photographs,
            drawings, logos, images, sounds, music, video or audio files, are protected by copyright
            owned or licensed by us and our logo and all other logos used in association with the
            Service are owned by the Company, its licensors, or other providers of such material and
            are protected by United States and international copyright, trademark, patent, trade
            secret, and other intellectual property or proprietary rights laws. You agree not to
            take any action(s) inconsistent with such ownership interests. We and our affiliates,
            licensors, and users, as applicable, reserve all rights in connection with the Service
            and its content, including, without limitation, the exclusive right to create derivative
            works. You may not use any metatags or other “hidden text” utilizing “Gamma” or any
            other name, trademark, service mark, or product or service name of Gamma or our
            affiliates or licensors without our prior written permission. You shall have no rights
            or interests therein except as set forth in these Terms. You agree that you shall not
            remove, obscure, or alter any proprietary rights notices (including copyright and
            trademark notices) that may be affixed to or contained within the Site or the
            information provided therein.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            License to Access and Use Our Service and Content
          </div>
          <div style={{ marginBottom: '10px' }}>
            You are hereby granted a limited, nonexclusive, nontransferable, non-sublicensable, and
            personal license to access and use the Service; provided, however, that such license is
            subject to your compliance with these Terms. If any software, content, or other
            materials owned by, controlled by, or licensed to us are distributed or made available
            to you as part of your use of the Service, we hereby grant you a non-commercial,
            personal, non-assignable, non-sublicensable, non-transferrable, and non-exclusive right,
            and license to access and display such software, content, and materials provided to you
            as part of the Service, in each case for the sole purpose of enabling you to use the
            Service as permitted by these Terms, provided that your license in any content linked to
            or associated with any NFTs is solely as set forth by the applicable seller or creator
            of such NFT.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Account Profile</div>
          <div style={{ marginBottom: '10px' }}>
            We provide you with the ability to customize and curate your own Account profile using
            your NFT collectibles and user-owned data. We enable this using Gaia, which allows you
            to create and share a data store that is associated with your decentralized wallet. When
            you connect this data to Gamma, you are giving Gamma access to this information to
            enrich your profile experience, but you will always remain its owner. Accordingly, you
            give Gamma a worldwide, non-exclusive, sublicensable, royalty-free license to use, copy,
            modify, and display this content on or through the Service for the limited purpose of
            providing these Account features.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>Feedback</div>
          <div style={{ marginBottom: '10px' }}>
            Any information, material, or idea you submit through the Service will be considered
            non-confidential and non-proprietary. You acknowledge and expressly agree that any
            contribution of feedback, comments, and suggestions for improvements to the Service
            (“Feedback”) does not and will not give or grant you any right, title, or interest in
            the Service or in any such Feedback. You agree that Gamma may use and disclose Feedback
            in any manner and for any purpose whatsoever without further notice or compensation to
            you and without retention by you of any proprietary or other right or claim. You hereby
            assign to Gamma any and all right, title, and interest (including, but not limited to,
            any patent, copyright, trade secret, trademark, show-how, know-how, moral rights and any
            and all other intellectual property right) that you may have in and to any and all
            Feedback.
          </div>
          <div style={{ textDecoration: 'underline', marginBottom: '10px' }}>
            Other User Submissions
          </div>
          <div style={{ marginBottom: '10px' }}>
            The Service may contain profiles, message boards, creator portals, and other interactive
            features that allow users to post, submit, publish, display, or transmit to other users
            or other persons content or materials (collectively “User Contributions”) on the Site or
            through the Service. This includes any digital file, art, or other material linked to or
            associated with any NFTs that are displayed on the Service. All User Contributions must
            comply with Gamma’s content standards that are posted on the Site.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Any User Contribution you post to the Site or through the Service will be considered
            non-confidential and non-proprietary. By providing any User Contribution on the Site or
            through the Service, you grant Gamma and its licensee, successors, and assigns a
            worldwide, non-exclusive, sublicensable, royalty-free limited license to use, display,
            distribute, and otherwise disclose to any third party any such User Contribution you
            submit or post on or through the Service for the limited purposes of providing,
            promoting, and improving the Service and as authorized in your user account settings, if
            any. You still retain the ownership and remain the copyright holder of such User
            Contributions.
          </div>
          <div style={{ marginBottom: '10px' }}>
            You represent and warrant that you have, or have obtained, all rights, licenses,
            consents, permissions, power and/or authority necessary to grant the rights granted
            herein for any content that you create, submit, post, promote, or display on or through
            the Service. You represent and warrant that such content does not contain material
            subject to copyright, trademark, publicity rights, or other intellectual property
            rights, unless you have necessary permission or are otherwise legally entitled to post
            the material and to grant Gamma the license described above, and that the content does
            not violate any laws.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Copyright
          </div>
          <div style={{ marginBottom: '10px' }}>
            We take claims of copyright infringement seriously. We will respond to notices of
            alleged copyright infringement that comply with applicable law. If you believe any
            materials accessible on or from the Service infringe your copyright, you may request
            removal of those materials (or access to them) from the Service by submitting written
            notification to our copyright agent designated below.
          </div>
          <div style={{ marginBottom: '10px' }}>
            In accordance with the Online Copyright Infringement Liability Limitation Act of the
            Digital Millennium Copyright Act (17 U.S.C. § 512) (“DMCA”), the written notice (the
            “DMCA Notice”) must include substantially the following:
          </div>
          <ul style={{ marginBottom: '10px' }}>
            <li style={{ marginBottom: '10px' }}>Your physical or electronic signature.</li>
            <li style={{ marginBottom: '10px' }}>
              Identification of the copyrighted work you believe to have been infringed or, if the
              claim involves multiple works on the Website, a representative list of such works.
            </li>
            <li style={{ marginBottom: '10px' }}>
              Identification of the material you believe to be infringing in a sufficiently precise
              manner to allow us to locate that material.
            </li>
            <li style={{ marginBottom: '10px' }}>
              Adequate information by which we can contact you (including your name, postal address,
              telephone number, and, if available, email address).
            </li>
            <li style={{ marginBottom: '10px' }}>
              A statement that you have a good faith belief that use of the copyrighted material is
              not authorized by the copyright owner, its agent, or the law.
            </li>
            <li style={{ marginBottom: '10px' }}>
              A statement that the information in the written notice is accurate.
            </li>
            <li style={{ marginBottom: '10px' }}>
              A statement, under penalty of perjury, that you are authorized to act on behalf of the
              copyright owner.
            </li>
          </ul>
          <div style={{ marginBottom: '10px' }}>
            Our designated copyright agent to receive DMCA Notices is:
          </div>
          <div style={{ marginBottom: '10px', paddingLeft: '20px' }}>
            <div>STXNFT, Inc.</div>
            <div>Attn: Legal Department</div>
            <div>548 Market Street</div>
            <div>PMB 42213</div>
            <div>San Francisco, CA 94104</div>
            <div>(415) 766-2146</div>
            <div>copyright@gamma.io</div>
          </div>
          <div style={{ marginBottom: '10px' }}>
            If you fail to comply with all of the requirements of Section 512(c)(3) of the DMCA,
            your DMCA Notice may not be effective.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Please be aware that if you knowingly materially misrepresent that material or activity
            on the Website is infringing your copyright, you may be held liable for damages
            (including costs and attorneys’ fees) under Section 512(f) of the DMCA.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Assumption of Risk
          </div>
          <div style={{ marginBottom: '10px' }}>
            This Section is about the risks you assume when you use our Service. You accept and
            acknowledge that:
          </div>
          <ul style={{ marginBottom: '10px' }}>
            <li style={{ marginBottom: '10px' }}>
              The value of an NFT is subjective. Prices of NFTs are subject to volatility and
              fluctuations in the price of cryptocurrency can also materially and adversely affect
              NFT prices. You fully understand this subjectivity and volatility and that you may
              lose money.
            </li>
            <li style={{ marginBottom: '10px' }}>
              A lack of use or public interest in the creation and development of distributed
              ecosystems could negatively impact the development of those ecosystems and related
              applications, and could therefore also negatively impact the potential utility of
              NFTs.
            </li>
            <li style={{ marginBottom: '10px' }}>
              The regulatory regime governing blockchain technologies, non-fungible tokens,
              cryptocurrency, and other crypto-based items is uncertain, and new regulations or
              policies may materially adversely affect the development of the Service and the
              utility of NFTs.
            </li>
            <li style={{ marginBottom: '10px' }}>
              You are solely responsible for determining what, if any, taxes apply to your
              transactions. Gamma is not responsible for determining the taxes that apply to your
              NFTs.
            </li>
            <li style={{ marginBottom: '10px' }}>
              There are risks associated with purchasing items associated with content created by
              third parties through peer-to-peer transactions, including but not limited to, the
              risk of purchasing counterfeit items, mislabeled items, items that are vulnerable to
              metadata decay, items on smart contracts with bugs, and items that may become
              non-transferable. You represent and warrant that you have done sufficient research
              before making any decisions to sell, obtain, transfer, or otherwise interact with any
              NFTs or accounts/collections.
            </li>
            <li style={{ marginBottom: '10px' }}>
              We do not control the public blockchains that you are interacting with and we do not
              control certain smart contracts and protocols that may be integral to your ability to
              complete transactions on these public blockchains. Additionally, blockchain
              transactions are irreversible, and Gamma has no ability to reverse any transactions on
              the blockchain.
            </li>
            <li style={{ marginBottom: '10px' }}>
              There are risks associated with using Internet and blockchain-based products,
              including, but not limited to, the risk associated with hardware, software, and
              Internet connections, the risk of malicious software introduction, and the risk that
              third parties may obtain unauthorized access to your third-party wallet or Account.
              You accept and acknowledge that Gamma will not be responsible for any communication
              failures, disruptions, errors, distortions, or delays you may experience when using
              the Service or any blockchain network, however caused.
            </li>
            <li style={{ marginBottom: '10px' }}>
              The Service relies on Third Party Providers. If we are unable to maintain a good
              relationship with such Third Party Providers; if the terms and conditions or pricing
              of such Third Party Providers change; if we violate or cannot comply with the terms
              and conditions of such Third Party Providers; or if any of such Third Party Providers
              loses market share or falls out of favor or is unavailable for a prolonged period of
              time, access to and use of the Service will suffer.
            </li>
            <li style={{ marginBottom: '10px' }}>
              Gamma reserves the right to hide collections, contracts, and items affected by any of
              these issues or by other issues. Items you purchase may become inaccessible on Gamma.
              Under no circumstances shall the inability to view items on Gamma or an inability to
              use the Service in conjunction with the purchase, sale, or transfer of items available
              on any blockchains serve as grounds for a claim against Gamma.
            </li>
            <li style={{ marginBottom: '10px' }}>
              If you have a dispute with one or more users, YOU RELEASE US FROM CLAIMS, DEMANDS, AND
              DAMAGES OF EVERY KIND AND NATURE, KNOWN AND UNKNOWN, ARISING OUT OF OR IN ANY WAY
              CONNECTED WITH SUCH DISPUTES. IN ENTERING INTO THIS RELEASE YOU EXPRESSLY WAIVE ANY
              PROTECTIONS (WHETHER STATUTORY OR OTHERWISE) THAT WOULD OTHERWISE LIMIT THE COVERAGE
              OF THIS RELEASE TO INCLUDE THOSE CLAIMS WHICH YOU MAY KNOW OR SUSPECT TO EXIST IN YOUR
              FAVOR AT THE TIME OF AGREEING TO THIS RELEASE.
            </li>
          </ul>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div style={{ textDecoration: 'underline', marginBottom: '10px', fontWeight: 'bold' }}>
            Indemnification
          </div>
          <div style={{ marginBottom: '10px' }}>
            By agreeing to these Terms and accessing the Service, you agree, to the fullest extent
            permitted by applicable law, to indemnify, defend, and hold harmless Gamma, its
            affiliates, licensors, and service providers, and its and their respective officers,
            directors, employees, contractors, agents, licensors, suppliers, successors, and assigns
            (individually and collectively, the “Gamma Parties”), from and against any claims,
            liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including
            reasonable attorneys’ fees) (“Claims”) arising out of or relating to (a) your use or
            misuse of the Service, content, NFTs, or content linked to or associated with any NFTs,
            (b) your submissions to the Service, (c) your violation or breach of any term of these
            Terms or applicable law, (d) your violation of the rights of or obligations to a third
            party, including another user or third-party, and (e) your negligence or willful
            misconduct. You agree to promptly notify Gamma of any Claims and cooperate with the
            Gamma Parties in defending such Claims. You further agree that the Gamma Parties shall
            have control of the defense or settlement of any Claims. THIS INDEMNITY IS IN ADDITION
            TO, AND NOT IN LIEU OF, ANY OTHER INDEMNITIES SET FORTH IN AN AGREEMENT BETWEEN YOU AND
            GAMMA.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Disclaimers
          </div>
          <div style={{ marginBottom: '10px' }}>
            YOUR ACCESS TO AND USE OF THE SERVICE IS AT YOUR OWN RISK. YOU UNDERSTAND AND AGREE THAT
            THE SERVICE IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS AND GAMMA EXPRESSLY
            DISCLAIMS WARRANTIES OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED. GAMMA (AND
            ITS THIRD PARTY PROVIDERS) MAKE NO WARRANTY OR REPRESENTATION AND DISCLAIM ALL
            RESPONSIBILITY FOR WHETHER THE SERVICE WILL: (A) MEET YOUR REQUIREMENTS; (B) BE
            AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS; OR (C) BE ACCURATE,
            RELIABLE, COMPLETE, LEGAL, OR SAFE. GAMMA DISCLAIMS ALL OTHER WARRANTIES OR CONDITIONS,
            EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OR CONDITIONS OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. GAMMA
            WILL NOT BE LIABLE FOR ANY LOSS OF ANY KIND FROM ANY ACTION TAKEN OR TAKEN IN RELIANCE
            ON MATERIAL OR INFORMATION, CONTAINED ON THE SERVICE. WHILE GAMMA ATTEMPTS TO MAKE YOUR
            ACCESS TO AND USE OF THE SERVICE SAFE, GAMMA CANNOT AND DOES NOT REPRESENT OR WARRANT
            THAT THE SERVICE, CONTENT, CONTENT LINKED TO OR ASSOCIATED WITH ANY NFTS, OR ANY NFTS
            YOU INTERACT WITH USING OUR SERVICE OR OUR SERVICE PROVIDERS’ SERVERS ARE FREE OF
            VIRUSES OR OTHER HARMFUL COMPONENTS. WE CANNOT GUARANTEE THE SECURITY OF ANY DATA THAT
            YOU DISCLOSE ONLINE. NO ADVICE OR INFORMATION, WHETHER ORAL OR OBTAINED FROM THE GAMMA
            PARTIES OR THROUGH THE SERVICE, WILL CREATE ANY WARRANTY OR REPRESENTATION NOT EXPRESSLY
            MADE HEREIN. YOU ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING INFORMATION AND DEALING
            ONLINE OVER THE INTERNET AND WILL NOT HOLD GAMMA RESPONSIBLE FOR ANY BREACH OF SECURITY.
          </div>
          <div style={{ marginBottom: '10px' }}>
            WE WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSS AND TAKE NO RESPONSIBILITY FOR,
            AND WILL NOT BE LIABLE TO YOU FOR, ANY USE OF NFTS, CONTENT, AND/OR CONTENT LINKED TO OR
            ASSOCIATED WITH NFTS, INCLUDING BUT NOT LIMITED TO ANY LOSSES, DAMAGES, OR CLAIMS
            ARISING FROM: (A) USER ERROR, INCORRECTLY CONSTRUCTED TRANSACTIONS, OR MISTYPED
            ADDRESSES; (B) SERVER FAILURE OR DATA LOSS; (C) UNAUTHORIZED ACCESS OR USE; AND/OR (D)
            ANY UNAUTHORIZED THIRD-PARTY ACTIVITIES, INCLUDING WITHOUT LIMITATION THE USE OF
            VIRUSES, PHISHING, BRUTE FORCING, OR OTHER MEANS OF ATTACK AGAINST THE SERVICE OR NFTS.
          </div>
          <div style={{ marginBottom: '10px' }}>
            NFTS EXIST ONLY BY VIRTUE OF THE OWNERSHIP RECORD MAINTAINED IN THE ASSOCIATED
            BLOCKCHAIN (E.G., BITCOIN NETWORK). ANY TRANSFERS OR SALES OCCUR ON THE ASSOCIATED
            BLOCKCHAIN (E.G., BITCOIN). GAMMA AND/OR ANY OTHER GAMMA PARTY CANNOT EFFECT OR
            OTHERWISE CONTROL THE TRANSFER OF TITLE OR RIGHT IN ANY NFTS OR UNDERLYING OR ASSOCIATED
            CONTENT OR ITEMS.
          </div>
          <div style={{ marginBottom: '10px' }}>
            NO GAMMA PARTY IS RESPONSIBLE OR LIABLE FOR ANY SUSTAINED LOSSES OR INJURY DUE TO
            VULNERABILITY OR ANY KIND OF FAILURE, ABNORMAL BEHAVIOR OF SOFTWARE (E.G., WALLET, SMART
            CONTRACT), BLOCKCHAINS OR ANY OTHER FEATURES OF THE NFTS. NO GAMMA PARTY IS RESPONSIBLE
            FOR LOSSES OR INJURY DUE TO LATE REPORTS BY DEVELOPERS OR REPRESENTATIVES (OR NO REPORT
            AT ALL) OF ANY ISSUES WITH THE BLOCKCHAIN SUPPORTING THE NFTS, INCLUDING FORKS,
            TECHNICAL NODE ISSUES, OR ANY OTHER ISSUES HAVING LOSSES OR INJURY AS A RESULT.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Some jurisdictions do not allow the exclusion of implied warranties in contracts with
            consumers, so the above exclusion may not apply to you.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Limitation of Liability
          </div>
          <div style={{ marginBottom: '10px' }}>
            TO THE FULLEST EXTENT PERMITTED BY LAW, YOU AGREE THAT IN NO EVENT WILL GAMMA OR ITS
            SERVICE PROVIDERS BE LIABLE TO YOU OR ANY THIRD PARTY FOR (A) ANY LOST PROFIT OR ANY
            INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES ARISING
            FROM THESE TERMS OR THE SERVICE, PRODUCTS, OR THIRD-PARTY SITES AND PRODUCTS, OR FOR ANY
            DAMAGES RELATED TO LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS, OR ANTICIPATED
            SAVINGS, LOSS OF USE, LOSS OF GOODWILL, OR LOSS OF DATA, AND WHETHER CAUSED BY STRICT
            LIABILITY OR TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF
            FORESEEABLE AND EVEN IF GAMMA OR ITS SERVICE PROVIDERS HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES; OR (B) FOR ANY OTHER CLAIM, DEMAND, OR DAMAGES WHATSOEVER
            RESULTING FROM OR ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OF THE DELIVERY, USE,
            OR PERFORMANCE OF THE SERVICE. ACCESS TO, AND USE OF, THE SERVICE, PRODUCTS, OR
            THIRD-PARTY SITES, AND PRODUCTS ARE AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE
            SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR MOBILE DEVICE OR LOSS OF
            DATA RESULTING THEREFROM.
          </div>
          <div style={{ marginBottom: '10px' }}>
            NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, IN NO EVENT SHALL THE MAXIMUM
            AGGREGATE LIABILITY OF GAMMA ARISING OUT OF OR IN ANY WAY RELATED TO THESE TERMS, THE
            ACCESS TO, AND USE OF THE SERVICE, CONTENT, NFTS, OR ANY GAMMA PRODUCTS OR SERVICES
            EXCEED THE GREATER OF (A) $100 OR (B) THE AMOUNT RECEIVED BY GAMMA FOR ITS SERVICE
            DIRECTLY RELATING TO THE ITEMS THAT ARE THE SUBJECT OF THE CLAIM. THE FOREGOING
            LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Any claims arising in connection with your use of the Site or any information thereon
            must be brought within one (1) year after the cause of action accrues; otherwise, such
            cause of action or claim is permanently barred. Remedies under these Terms are exclusive
            and are limited to those expressly provided for in these Terms. If you are dissatisfied
            with the Service, your sole and exclusive remedy shall be to discontinue use of the
            Service.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Some jurisdictions do not allow the exclusion or limitation of incidental or
            consequential damages, so the above limitation or exclusion may not apply to you. Some
            jurisdictions also limit disclaimers or limitations of liability for personal injury
            from consumer products, so this limitation may not apply to personal injury claims.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Limitations On Liability For Third-Party Providers
          </div>
          <div style={{ marginBottom: '10px' }}>
            YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOU HAVE NO CONTRACTUAL RELATIONSHIP WITH ANY OF
            OUR THIRD PARTY PROVIDERS, AND THAT YOU ARE NOT A THIRD PARTY BENEFICIARY OF ANY
            AGREEMENT BETWEEN COMPANY AND ANY THIRD PARTY PROVIDER. IN ADDITION, YOU ACKNOWLEDGE
            THAT ALL SUCH THIRD PARTY PROVIDERS SHALL HAVE NO LEGAL, EQUITABLE, OR OTHER LIABILITY
            OF ANY KIND TO ANY USER, AND YOU HEREBY WAIVE AND DISCLAIM ANY AND ALL CLAIMS OR DEMANDS
            OF SUCH NATURE. YOU ACKNOWLEDGE AND AGREE THAT ANY THIRD PARTY PROVIDERS HAVE NO
            OBLIGATION FOR ANY WARRANTY, EXPRESS OR IMPLIED OF ANY KIND WHATSOEVER (INCLUDING
            WITHOUT LIMITATION, WARRANTIES OF TITLE OR NON-INFRINGEMENT, OR ANY WARRANTIES OF
            MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE) WITH REGARD TO THE INFORMATION
            PROVIDED ON OR THROUGH THE SERVICE. YOU FURTHER ACKNOWLEDGE AND AGREE THAT SUCH THIRD
            PARTY PROVIDERS, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, SHALL HAVE NO OTHER
            WARRANTY OBLIGATION WHATSOEVER WITH RESPECT TO THE INFORMATION PROVIDED, AND ANY OTHER
            CLAIMS, LOSSES, LIABILITIES, DAMAGES, COSTS OR EXPENSES ATTRIBUTABLE TO ANY FAILURE TO
            CONFORM TO ANY WARRANTY WILL BE SOLELY AS PERMITTED UNDER THESE TERMS.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Bargained For Basis
          </div>
          <div style={{ marginBottom: '10px' }}>
            YOU ACKNOWLEDGE AND AGREE THAT THE LIMITATIONS OF LIABILITY SET FORTH ABOVE ARE
            FUNDAMENTAL ELEMENTS OF THESE TERMS AND NEITHER THE SERVICES, THE SITE, NOR THE
            INFORMATION THEREON WOULD BE PROVIDED TO YOU ABSENT SUCH LIMITATIONS OF LIABILITY.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Modifications to the Service
          </div>
          <div>
            We reserve the right in our sole discretion to modify, suspend, or discontinue,
            temporarily or permanently, the Service (or any features or parts thereof) at any time
            and without liability as a result.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Dispute Resolution; Arbitration
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Dispute Resolution</span>. Please read the
            following arbitration agreement in this Section 15 (“Arbitration Agreement”) carefully.
            It requires you to arbitrate disputes with Gamma and limits the manner in which you can
            seek relief from us. This Section does not govern disputes between users or between
            users and third parties. Gamma does not provide dispute resolution services for such
            disagreements and the parties must resolve those disputes directly.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>
              Applicability of Arbitration Agreement
            </span>
            . You agree that any dispute, controversy, or claim relating in any way to your access
            or use of the Service, to any products sold or distributed through the Service, or to
            any aspect of your relationship with Gamma, will be resolved by binding arbitration,
            rather than in court, including threshold questions of the arbitrability of such
            dispute, controversy, or claim except that (1) you or Gamma may assert claims in small
            claims court, but only if the claims qualify, the claims remain only in such court, and
            the claims remain on an individual, non-representative, and non-class basis, and (2) you
            or Gamma may seek injunctive or equitable relief in a court of proper jurisdiction if
            the claim relates to intellectual property infringement or other misuse of intellectual
            property rights.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Dispute Resolution Process</span>. You and
            Gamma both agree to engage in good-faith efforts to resolve disputes prior to either
            party initiating an arbitration, small claims court proceeding, or equitable relief for
            intellectual property infringement. You must initiate this dispute resolution process by
            sending a letter describing the nature of your claim and desired resolution to Gamma via
            mail and email to the addresses set forth for copyright notices in Section 7 above. Both
            parties agree to meet and confer personally, by telephone, or by videoconference
            (hereinafter “Conference”) to discuss the dispute and attempt in good faith to reach a
            mutually beneficial outcome that avoids the expenses of arbitration or, where
            applicable, litigation. If you are represented by counsel, your counsel may participate
            in the Conference as well, but you agree to fully participate in the Conference.
            Likewise, if Gamma is represented by counsel, its counsel may participate in the
            Conference as well, but Gamma agrees to have a company representative fully participate
            in the Conference. The statute of limitations and any filing fee deadlines shall be
            tolled while the parties engage in the informal dispute resolution process and
            Conference required by this paragraph. If the parties do not reach agreement to resolve
            the dispute within thirty (30) days after initiation of this dispute resolution process,
            either party may commence arbitration, file an action in small claims court, or file a
            claim for injunctive or equitable relief in a court of proper jurisdiction for matters
            relating to intellectual property infringement, if the claims qualify.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Arbitration Rules and Forum</span>. The
            Federal Arbitration Act governs the interpretation and enforcement of this Arbitration
            Agreement. To begin an arbitration proceeding after participating in the dispute
            resolution process, you must send a letter (via email and mail) requesting arbitration
            and describing your claim to our registered agent at the addresses set forth for
            copyright notices in Section 7 above. The disputes and claims subject to arbitration
            will be resolved by a single arbitrator mutually agreed upon by you and Gamma. If we the
            parties cannot agree on an arbitrator, then an arbitrator shall be selected pursuant to
            Rule 12 of the JAMS Streamlined Arbitration Rules and Procedures. The arbitrator shall
            be bound by and shall strictly enforce these Terms and any other applicable agreement
            between us, and may not limit, expand, or otherwise modify any such terms. The
            arbitrator may award any relief that a court of law could, applying the limitations of
            liability contained in these Terms. The arbitrator may award injunctive relief if
            permitted by law – but the injunctive relief awarded by the arbitrator may not extend
            beyond our dealings with one another. Any arbitration will be held in New York, NY,
            unless otherwise agreed upon by you and Gamma in writing. You and Gamma will each bear
            its own expenses in the arbitration and will share equally the costs of the arbitration;
            provided, however, that the arbitrator shall award costs and fees to the prevailing
            party if it is determined that the other party submitted a claim with no reasonable
            basis or filed any claim in bad faith.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Authority of Arbitrator</span>. The
            arbitrator shall have exclusive authority to (a) determine the scope and enforceability
            of this Arbitration Agreement, and (b) resolve any dispute related to the
            interpretation, applicability, enforceability, or formation of this Arbitration
            Agreement including, but not limited to, any claim that all or any part of this
            Arbitration Agreement is void or voidable. The arbitration will decide the rights and
            liabilities, if any, of you and Gamma. The arbitration proceeding will not be
            consolidated with any other matters or joined with any other cases or parties. The
            arbitrator shall have the authority to grant motions dispositive of all or part of any
            claim. The arbitrator shall have the authority to award monetary damages and to grant
            any non-monetary remedy or relief available to an individual under applicable law, the
            arbitral forum’s rules, and these Terms. The arbitrator shall issue a written award and
            statement of decision describing the essential findings and conclusions on which the
            award is based, including the calculation of any damages awarded. The arbitrator has the
            same authority to award relief on an individual basis that a judge in a court of law
            would have. The award of the arbitrator is final and binding upon you and us. Any
            judgment on the award rendered by the arbitrator may be entered in any court of
            competent jurisdiction.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Waiver of Jury Trial</span>. YOU AND GAMMA
            HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO SUE IN COURT AND HAVE A TRIAL IN
            FRONT OF A JUDGE OR A JURY. You and Gamma are instead electing that all claims and
            disputes shall be resolved by arbitration under this Arbitration Agreement, except as
            specified in the second paragraph labelled “Applicability of Arbitration Agreement”
            above. An arbitrator can award on an individual basis the same damages and relief as a
            court and must follow these Terms as a court would. However, there is no judge or jury
            in arbitration, and court review of an arbitration award is subject to very limited
            review.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>
              Waiver of Class Actions and Class Arbitrations
            </span>
            . ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION AGREEMENT MUST BE
            ARBITRATED ON AN INDIVIDUAL BASIS AND NOT ON A REPRESENTATIVE OR COLLECTIVE CLASS BASIS.
            ONLY INDIVIDUAL RELIEF IS AVAILABLE, AND CLAIMS OF MORE THAN ONE USER, PERSON, OR ENTITY
            CANNOT BE ARBITRATED OR CONSOLIDATED WITH THOSE OF ANY OTHER USER, PERSON, OR ENTITY.
            Accordingly, under the arbitration procedures outlined in this Section, an arbitrator
            shall not combine or consolidate more than one party’s claims without the written
            consent of all affected parties to an arbitration proceeding. Without limiting the
            generality of the foregoing, you and Gamma agree that no dispute shall proceed by way of
            class arbitration without the written consent of all affected parties. If a decision is
            issued stating that applicable law precludes enforcement of any part of this
            subsection’s limitations as to a given claim for relief, then that claim must be severed
            from the arbitration and brought in the state or federal courts located in the Southern
            District of New York. All other claims shall be arbitrated.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Severability</span>. Except as provided in
            this Section, if any part or parts of this Arbitration Agreement are found under the law
            to be invalid or unenforceable, then such specific part or parts shall be of no force
            and effect and shall be severed and the remainder of the Arbitration Agreement shall
            continue in full force and effect.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Survival of Agreement</span>. This
            Arbitration Agreement will survive the termination of your relationship with Gamma and
            your use of the Service.
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ textDecoration: 'underline' }}>Modification</span>. Notwithstanding any
            provision in these Terms to the contrary, we agree that if Gamma makes any future
            material change to this Arbitration Agreement, you may reject that change within thirty
            (30) days of such change becoming effective by writing (via mail and email) to Gamma at
            the addresses set forth for copyright notices in Section 7 above.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Governing Law and Venue
          </div>
          <div style={{ marginBottom: '10px' }}>
            These Terms and your access to and use of the Service shall be governed by and construed
            and enforced in accordance with the laws of the State of Delaware (without regard to
            conflict of law rules or principles of the State of State of Delaware. You and Gamma
            agree that the United Nations Convention on Contracts for the International Sale of
            Goods will not apply to the interpretation or construction of these Terms.
          </div>
          <div style={{ marginBottom: '10px' }}>
            Any dispute between the parties that is not subject to arbitration as set forth in
            Section 15 above or cannot be heard in small claims court, shall be resolved in the
            state or federal courts sitting in the Southern District of New York.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Termination
          </div>
          <div style={{ marginBottom: '10px' }}>
            If you breach any of the provisions of these Terms, all licenses granted by Gamma will
            terminate automatically. Additionally, notwithstanding anything contained in these
            Terms, we reserve the right, with or without notice and in our sole discretion, to
            suspend, disable, terminate, or delete your Account and/or your ability to access or use
            the Service (or any part of the foregoing) at any time and for any or no reason, and you
            acknowledge and agree that we shall have no liability or obligation to you in such event
            and that you will not be entitled to a refund of any amounts that you have already paid
            to us.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            No Waiver; Severability
          </div>
          <div style={{ marginBottom: '10px' }}>
            Any failure on the part of a party to these Terms to insist upon strict enforcement of
            any provision(s) of these Terms shall not be construed as a waiver of any provision or
            right. Should any provision of these Terms be held invalid or unenforceable, such
            invalidity will not invalidate the whole of these Terms, but rather that invalid
            provision will be amended to achieve as nearly as possible the same economic effect as
            the original provision and the remainder of these Terms will remain in full force and
            effect.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Injunctive Relief
          </div>
          <div style={{ marginBottom: '10px' }}>
            You agree that a breach of these Terms will cause irreparable injury to Gamma for which
            monetary damages would not be an adequate remedy and Gamma shall be entitled to
            equitable relief in addition to any remedies it may have hereunder or at law without a
            bond, other security, or proof of damages.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            California Residents
          </div>
          <div style={{ marginBottom: '10px' }}>
            If you are a California resident, in accordance with Cal. Civ. Code § 1789.3, you may
            report complaints to the Complaint Assistance Unit of the Division of Consumer Services
            of the California Department of Consumer Affairs by contacting them in writing at 1625
            North Market Blvd., Suite N 112 Sacramento, CA 95834, or by telephone at (800) 952-5210.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Survival
          </div>
          <div style={{ marginBottom: '10px' }}>
            All sections which by their nature should survive the termination of these Terms shall
            continue in full force and effect subsequent to and notwithstanding any termination of
            these Terms by Gamma or you. Termination will not limit any of Gamma’s other rights or
            remedies at law or in equity.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Miscellaneous
          </div>
          <div style={{ marginBottom: '10px' }}>
            These Terms constitute the entire agreement between you and Gamma relating to your
            access to and use of the Service and supersedes all prior agreements with respect to the
            content of these Terms. These Terms, and any rights and licenses granted hereunder, may
            not be transferred or assigned by you without the prior written consent of Gamma, and
            Gamma’s failure to assert any right or provision under these Terms shall not constitute
            a waiver of such right or provision. No waiver by either party of any breach or default
            hereunder shall be deemed to be a waiver of any preceding or subsequent breach or
            default. The section headings used herein are for reference only and shall not be read
            to have any legal effect. Except as otherwise provided herein, these Terms are intended
            solely for the benefit of the parties and are not intended to confer third-party
            beneficiary rights upon any other person or entity.
          </div>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <div
            style={{
              textDecoration: 'underline',
              marginBottom: '10px',
              paddingLeft: '20px',
              fontWeight: 'bold',
            }}
          >
            Comments and Concerns
          </div>
          <div style={{ marginBottom: '10px' }}>
            All notices, feedback, comments, requests for technical support, and other
            communications relating to the Site should be directed to Gamma at support@gamma.io.
          </div>
        </li>
      </ol>
      <div style={{ marginBottom: '10px' }}>
        Copyright © STXNFT, Inc., dba Gamma. 2022. All rights reserved.
      </div>
    </ContainerFull>
  );
}
